<div>{{message}}</div><br/>
<div>You may want to update/close these associated records:</div><br/>
<ul>
  <li>DAC6 & MDR Reports</li>
  <li *ngIf="isExistTask" >1 Task(<a style="cursor: pointer;" (click)="showTask( )">{{taskDisplayId}}</a>)</li>
</ul>
<br/>
<b>{{question}}</b><br/>
